export default __webpack_public_path__ + "static/media/coading image.9909a3cd.png";